module.exports = __webpack_public_path__ + "static/media/BoxPlotQ1_1.f9e18018.svg";